import * as Yup from "yup";


// Constants
export const INITIAL_VALUES_1 = {
  dispatch_temperature: '',
  serial_no: '',
  equipment_id: '',
  dispatch_time: "",
};
export const INITIAL_VALUES_2 = {
  "receipt_date": "",
  "patient_details_verified": false,
  "leakage_observed": false,
  "broken_seal": false,
  "broken_transport_box_comment": "",
  "broken_seal_comment": "",
  "leakage_observed_comment": "",
  "broken_transport_box": false,
  "receipt_time": "",
  "quantity_received": "",
  "receipt_temperature": "",
  "temperature_excursion_comment": "",
  "excursion_time": "",
  "excursion_temp": "",
  "excursion_duration": "",
}

export const STEP_SLUGS = {
  QUALITY_CONTROL: "qc-testing",
  PRODUCT_SHIPPED: "product-shipped",
  INFUSION: "infusion",
  PRODUCT_RECEIVED: "product-received"
};

export const STATUS_COMPLETED = 2;
export const STATUS_IN_PROGRESS = 1;
export const STATUS_SUBMITED = 4
export const STATUS_PENDING = 0
export const STATUS_FINAL_COMPLETE = 4

const requiredIfNotDraft = (schema, message, isDraft) =>
  isDraft ? schema.notRequired() : schema.required(message);


export const validationSchemaOutbondPart1 = (isDraft = false) =>
  Yup.object().shape({
    dispatch_temperature: requiredIfNotDraft(
      Yup.number()
        .nullable()
        .max(40, "Temperature at dispatch cannot be more than 40")
        .min(-80, "Temperature at dispatch cannot be less than -80")
        .test(
          "max-2-decimals",
          "Temperature at dispatch can have at most 2 decimal places",
          (value) =>
            value == null ||
            /^-?\d+(\.\d{1,2})?$/.test(value?.toString())
        ),
      "Temperature at dispatch is required",
      isDraft
    ),

    dispatch_time: requiredIfNotDraft(
      Yup.string().nullable(),
      "Time of dispatch is required",
      isDraft
    ),
    serial_no: requiredIfNotDraft(
      Yup.string().nullable(),
      "Serial no is required",
      isDraft
    ),
    equipment_id: requiredIfNotDraft(
      Yup.string().nullable(),
      "Equipment id is required",
      isDraft
    ),
  });

export const validationSchemaOutbondPart2 = (isDraft = false) =>
  Yup.object().shape({

    receipt_date: requiredIfNotDraft(
      Yup.string().nullable(),
      "Time of receipt is required",
      isDraft
    ),

    patient_details_verified: requiredIfNotDraft(
      Yup.boolean().nullable(),
      "Patient details verified is required",
      isDraft
    ),

    quantity_received: requiredIfNotDraft(
      Yup.number()
        .nullable()
        .integer("Quantity received must be a number"),
      "Quantity received is required",
      isDraft
    ),

    leakage_observed: requiredIfNotDraft(
      Yup.boolean().nullable(),
      "Leakage check is required",
      isDraft
    ),

    leakage_observed_comment: Yup.string()
      .nullable()
      .when(["leakage_observed"], {
        is: (val) => val === true && !isDraft,
        then: (schema) =>
          schema.required("Leakage check's comment is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    broken_seal: requiredIfNotDraft(
      Yup.boolean().nullable(),
      "Broken seal check is required",
      isDraft
    ),

    broken_seal_comment: Yup.string()
      .nullable()
      .when(["broken_seal"], {
        is: (val) => val === true && !isDraft,
        then: (schema) =>
          schema.required("Broken seal check's comment is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    broken_transport_box: requiredIfNotDraft(
      Yup.boolean().nullable(),
      "Broken transport box damaged check is required",
      isDraft
    ),

    broken_transport_box_comment: Yup.string()
      .nullable()
      .when(["broken_transport_box"], {
        is: (val) => val === true && !isDraft,
        then: (schema) =>
          schema.required("Broken transport box damaged's comment is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    temperature_excursion: requiredIfNotDraft(
      Yup.boolean().nullable(),
      "Temperature excursion is required",
      isDraft
    ),

    receipt_temperature: Yup.number()
      .nullable()
      .when(["temperature_excursion"], {
        is: (val) => (val === true || val === "true") && !isDraft,
        then: (schema) =>
          schema
            .required("Excursion temperature at dispatch is required")
            .max(100, "Excursion temperature at dispatch cannot be more than 100")
            .test(
              "max-2-decimals",
              "Excursion temperature at dispatch can have at most 2 decimal places",
              (value) =>
                value == null ||
                /^-?\d+(\.\d{1,2})?$/.test(value?.toString())
            ),
        otherwise: (schema) => schema.notRequired(),
      }),

    receipt_time: Yup.string()
      .nullable()
      .when(["temperature_excursion"], {
        is: (val) => (val === true || val === "true") && !isDraft,
        then: (schema) =>
          schema.required("Excursion time check is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    temperature_excursion_comment: Yup.string()
      .nullable()
      .when(["temperature_excursion"], {
        is: (val) => (val === true || val === "true") && !isDraft,
        then: (schema) =>
          schema.required("Excursion duration's comment is required"),
        otherwise: (schema) => schema.notRequired(),
      }),

    excursion_duration: Yup.string()
      .nullable()
      .when(["temperature_excursion"], {
        is: (val) => (val === true || val === "true") && !isDraft,
        then: (schema) =>
          schema
            .required("Excursion duration is required")
            .matches(
              /^(?:[01]\d|2[0-3])[:-][0-5]\d$/,
              "Excursion duration must be in HH:MM or HH-MM format (e.g., 22:33)"
            ),
        otherwise: (schema) => schema.notRequired(),
      }),
  });
